import { AxiosResponse } from 'axios';

import { api, authApi } from '../../http';
import { IdentityApiError, UserInfo } from '../../types/interfaces';
import { AuthResponse } from '../../types/interfaces/AuthResponse';

import { ApiResponse } from './interfaces';

export default class AuthService {
  static async login(
    username: string,
    password: string
  ): Promise<AxiosResponse<AuthResponse>> {
    return authApi.post<AuthResponse>('/login', { username, password });
  }

  static async loginWithCode(
    username: string,
    password: string,
    code: string
  ): Promise<AxiosResponse<AuthResponse>> {
    return authApi.post<AuthResponse>('/loginWithCode', {
      username,
      password,
      code
    });
  }

  static async logout(): Promise<void> {
    return authApi.post('/logout', {}, { withCredentials: true });
  }

  static async refresh(): Promise<AxiosResponse<AuthResponse>> {
    return authApi.post<AuthResponse>('/refresh', undefined, {
      withCredentials: true
    });
  }

  static async getUser(): Promise<AxiosResponse<ApiResponse<UserInfo>>> {
    return api.get('/user');
  }

  static async sendNewTwoFactorCode(
    username: string
  ): Promise<AxiosResponse<IdentityApiError | null>> {
    return authApi.post(
      '/sendNewTwoFactorCode',
      { username },
      {
        withCredentials: true
      }
    );
  }

  static async updatePassword(
    password: string
  ): Promise<AxiosResponse<ApiResponse<void>>> {
    const formData = new FormData();
    formData.append('password', password);
    
    return api.post('/user', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}
